export default {
    'diagram3b1-4': {
        'checkboxes': {
            'title': 'Question:	',
            'checkbox-1': 'Why was it more stable?',
            'checkbox-2': 'How was it more stable?',
            'checkbox-3': 'How do you know it was more stable?',
        },
        'elements': {
            'one': 'France exhibited a stability that was denied the independent city-states of Italy',
            'two': 'Less subject to the fickleness of voters',
            'three': 'More able to expand geographically',
            'four': 'More unified for action'
        },
        'checkboxes-bottom': {
            'title': 'General Plural Noun',
            'checkbox-1': 'Reasons',
            'checkbox-2': 'Steps',
            'checkbox-3': 'Proofs',
        },
    }
}



// WEBPACK FOOTER //
// ./client/app/components/diagrams/3/3b1/diagram4/i18n/en.js